export default __webpack_public_path__ + "static/media/offerHome.cfd62c6b.png";